import { render, staticRenderFns } from "./dropdownTable.vue?vue&type=template&id=4a234447&scoped=true"
import script from "./dropdownTable.vue?vue&type=script&lang=js"
export * from "./dropdownTable.vue?vue&type=script&lang=js"
import style0 from "./dropdownTable.vue?vue&type=style&index=0&id=4a234447&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a234447",
  null
  
)

export default component.exports